import React from 'react';
import style from 'acscp/components/itinerary/sharedItinerary.module.scss';
import UserIcon from 'acscp/assets/user.png';
import { BrokerShortDetails } from 'acscp/store';
import { MailTo } from 'acscp/components/common/mailToLink';
import { TelephoneLink } from 'acscp/components/common/telephoneLink';
import { AdditionalItem } from 'acscp/components/itinerary/additionalItem';
import { FormattedMessage } from 'react-intl';

export const ContactInfo: React.SFC<{ contact: BrokerShortDetails | null, title: React.ReactNode }> =
    ({contact, title}) => {
        if (!contact) {
            return null;
        }

        return (
            <AdditionalItem
                icon={UserIcon}
                label={title}
            >
                <div>{contact.fullname}</div>
                <div><TelephoneLink phoneNumber={contact.mobile}/></div>
                <div><MailTo email={contact.email} highlight={true} truncate={false}/></div>
            </AdditionalItem>
        );
    };
